module.exports = __webpack_public_path__ + "static/media/angle-down.97066915.svg";